<template>
  <div class="fill-height" style="width: 100%">
    <div class="fill-height d-flex flex-column align-center justify-center">
      <div class="d-flex justify-center" style="width: 100%;max-width: 300px;">
        <lottie-animation :animation-data="require('@/assets/rocket.json')" loop></lottie-animation>
      </div>
      <div class="pa-6 mt-4" style="width: 100%">
        <div class="text-h4 decoText font-weight-bold">{{ $t('CurrentTableNumber') }} {{ tableName }}</div>
        <div class="text-body-1 mt-4">{{ $t('OrderingExperience') }}</div>
        <v-btn
          block class="mt-4" color="primary black--text" elevation="0"
          x-large @click="openTable"
        >
          <v-icon left>mdi-run-fast</v-icon>
          {{ $t('OrderNow') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import LottieAnimation from 'lottie-web-vue'
import {getRestaurantInfo, getTableInfo, getTableName, openTableWithScanQR} from "@/dataLayer/service/api"
import {getCategoryWithDishes} from "@/dataLayer/service/dishService";
import {mapStores} from "pinia";
import {useUserStore} from "@/dataLayer/userStore";
import {useCartStore} from "@/dataLayer/service/CartService";
import {goto} from "@/plugins/router";
import IKUtils from "innerken-js-utils";
import {Remember} from "@/plugins/firebase";
import dayjs from "dayjs";
import {isHotpot} from "@/dataLayer/repository/HotpotViewmodel";
import store from "@/plugins/store"; // import lottie-web-vue


export default {
  components: {LottieAnimation},
  name: "LoadingPage",
  data: function () {
    return {
      tableName: getTableName(),
      isHotpot: false,
      fastFoodMode: !IKUtils.getQueryString("tableName"),
    }
  },
  computed: {
    ...mapStores(useUserStore, useCartStore)
  },
  methods: {
    hashcode(code) {
      let hash = 0, i, chr, len;
      if (code.length === 0) return hash;
      for (i = 0, len = code.length; i < len; i++) {
        chr = code.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0;
      }
      return hash;
    },
    async openAnnouncement() {
      const res = await getRestaurantInfo();
      const today = dayjs().format("YYYY-MM-DD");
      const announce = this.hashcode(res.buffetAnnouncementBody).toString();
      const oldDate = localStorage.getItem("date");
      const oldAnnounce = localStorage.getItem("announce");
      const timespan = dayjs(today).diff(oldDate, "day");
      if (!oldDate || timespan > 7) {
        localStorage.setItem("date", today);
        this.$store.commit("showAnnouncement", true);
      }
      if (oldAnnounce && oldAnnounce === announce) {
        return;
      }
      localStorage.setItem("announce", announce);
      this.$store.commit("showAnnouncement", true);
    },
    async openTable() {

      try {
        const res = await openTableWithScanQR((await getTableInfo()).id)
        this.isHotpot = await isHotpot()
        await this.cartStore.clearGlobalCart()
        if (res.status === 'good') {
          await goto('/')
          if (this.isHotpot) {
            await goto('/setting')
          } else {
            await goto('/menu')
          }
        } else {
          await goto('/')
          if (this.isHotpot) {
            await goto('/setting')
          } else {
            await goto('/menu')
          }
        }
      } catch (e) {
        console.log(e)
        await goto('/')
        await goto('/menu')
      }


    }
  },
  async mounted() {
    await getCategoryWithDishes('DE')
    if (this.fastFoodMode) {
      if (store.state.fastFoodModeOpen === '1') {
        if (Remember.modeSelected) {
          await goto('/menu')
        } else {
          await goto('/index')
        }
      } else {
        await goto('/error')
      }
    } else {
      const tableStatus = await getTableInfo()
      if (tableStatus?.usageStatus === '1') {
        await goto('/menu')
      }
    }
    await this.openAnnouncement()
  },
}
</script>

<style scoped>

</style>
